<template>
  <v-card>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title> Dashboard Analytics </v-toolbar-title>
    </v-toolbar>
    <v-tabs vertical>
      <v-tab>
        <v-icon left> mdi-cellphone-information </v-icon>
        App
      </v-tab>
      <v-tab>
        <v-icon left> mdi-account </v-icon>
        User
      </v-tab>

      <v-tab-item>
        <v-card flat>
          <v-card-text class="text-left">
            <v-row>
              <v-col> Total Downloads: </v-col>
              <v-col class="font-weight-black v-h5">
                {{
                  app_downloads.total_ios_downloads +
                  app_downloads.total_android_downloads
                }}
              </v-col>
              <v-col>
                <v-row>
                  <v-col>iOS:</v-col>
                  <v-col class="font-weight-black v-h5">{{
                    app_downloads.total_ios_downloads
                  }}</v-col>
                </v-row>
                <v-row>
                  <v-col>Android: </v-col>
                  <v-col class="font-weight-black v-h5">{{
                    app_downloads.total_android_downloads
                  }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col> Downloads Per Store: </v-col>
            </v-row>
            <v-row>
              <v-col> BBU - Bandar Baru Uda </v-col>
              <v-col class="font-weight-black v-h5"> {{ bbuDownloads }} </v-col>
            </v-row>
            <v-row>
              <v-col> JJ - Johor Jaya </v-col>
              <v-col class="font-weight-black v-h5"> {{ jjDownloads }} </v-col>
            </v-row>
            <v-row>
              <v-col> KL1 - Bandar Sunway Mentari </v-col>
              <v-col class="font-weight-black v-h5"> {{ kl1Downloads }} </v-col>
            </v-row>
            <v-row>
              <v-col> KL2 - Sungai Way </v-col>
              <v-col class="font-weight-black v-h5"> {{ kl2Downloads }} </v-col>
            </v-row>
            <v-row>
              <v-col> Masai - Masai </v-col>
              <v-col class="font-weight-black v-h5">
                {{ masaiDownloads }}
              </v-col>
            </v-row>
            <v-row>
              <v-col> HQ </v-col>
              <v-col class="font-weight-black v-h5">
                {{ hqDownloads }}
              </v-col>
            </v-row> -->
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text class="text-left">
            <v-row class="d-flex justify-end mb-6">
              <download-excel
                class="btn btn-primary download-btn"
                :data="csvData"
                :fields="json_fields"
                :worksheet="worksheet"
                :name="filename"
                v-show="isAdmin"
              >
                Export Report To Excel
              </download-excel>
            </v-row>

            <v-row class="d-flex justify-start col-md-6">
              <v-select
                v-model="dateSelected"
                :items="dateOptions"
                item-text="name"
                item-value="val"
                menu-props="auto"
                label="Filter by date"
                hint="Filter by date"
                hide-details
                prepend-icon="mdi-calendar"
                single-line
                @change="changeVal()"
              ></v-select>

              <!-- <v-row v-show="dateSelected == 'custom'"> -->
              <v-col v-show="dateSelected == 'custom'">
                <v-date-picker v-model="dates" range></v-date-picker>
                <v-text-field
                  v-model="dateRangeText"
                  label="Date range"
                  prepend-icon="mdi-calendar"
                  readonly
                ></v-text-field>
              </v-col>
              <!-- </v-row> -->
            </v-row>

            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left"></th>
                    <th class="text-left" style="width: 300px">
                      Option / Condition
                    </th>
                    <th class="text-left">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Total Number of New Signed-in User:</td>
                    <td>
                      <!-- <v-row>
                        <v-col>BBU</v-col>
                        <v-col>{{ bbuCount }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col>JJ</v-col>
                        <v-col>{{ jjCount }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col>KL1</v-col>
                        <v-col>{{ kl1Count }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col>KL2</v-col>
                        <v-col>{{ kl2Count }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col>Masai</v-col>
                        <v-col>{{ masaiCount }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col>HQ</v-col>
                        <v-col>{{ hqCount }}</v-col>
                      </v-row> -->
                    </td>
                    <td class="font-weight-black v-h5">{{ totalSignin }}</td>
                  </tr>
                  <tr>
                    <td>Total Active Users:</td>
                    <td></td>
                    <td class="font-weight-black v-h5">{{ totalActive }}</td>
                  </tr>
                  <tr>
                    <td>Total Users with Points:</td>
                    <td>
                      <v-row>
                        <v-col>
                          <v-select
                            :items="items"
                            label="Condition"
                            outlined
                            v-model="condition"
                          ></v-select>
                        </v-col>
                        <v-col>
                          <v-text-field
                            hint="Points"
                            placeholder="0"
                            outlined
                            v-model="points"
                            @change="changeVal()"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </td>
                    <td class="font-weight-black v-h5">
                      {{ totalWithPoints }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import Axios from "axios";
import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);

export default {
  data() {
    return {
      bbuCount: 0,
      jjCount: 0,
      kl1Count: 0,
      kl2Count: 0,
      masaiCount: 0,
      hqCount: 0,
      dialog: this.dateSelected == "custom" ? true : false,
      dateSelected: {},
      dateOptions: [
        { name: "Today", val: "tod" },
        { name: "Yesterday", val: "yes" },
        { name: "This week (Mon - Today)", val: "tw" },
        { name: "Last week (Mon - Sun)", val: "lw" },
        { name: "Last 7 days", val: "l7d" },
        { name: "Last 28 days", val: "l28d" },
        { name: "Last 30 days", val: "l30d" },
        { name: "Last 90 days", val: "l90d" },
        { name: "Last 12 months", val: "l12m" },
        { name: "Custom", val: "custom" },
      ],
      items: [">=", "<=", "=="],
      condition: ">=",
      points: 0,
      dates: [
        moment("2021-04-26").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      user_data: null,
      app_downloads: 0,
      filename: `Apps Report ${moment().format("DDMMYYYY")}.xls`,
      worksheet: moment().format("DD-MM-YYYY"),
      json_fields: {
        Name: "name",
        Value: "value",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      isAdmin:
        this.$store.state.user !== undefined
          ? this.$store.state.user.roles.admin
          : false,
    };
  },
  async created() {
    Axios.get(
      process.env.VUE_APP_HOST_SERVER + "/api/app_analytics/get_customers"
    ).then((res) => {
      console.log("Successfully retrieved all details");
      this.$store.commit("setUserData", res.data);
      this.user_data = res.data;
    });
    Axios.get(
      process.env.VUE_APP_HOST_SERVER + "/api/app_analytics/g_scraper"
    ).then(() => {
      console.log("Successfully updated download details");
      Axios.get(
        process.env.VUE_APP_HOST_SERVER + "/api/app_analytics/get_downloads"
      ).then((res) => {
        console.log("Successfully retrieved all details");
        this.app_downloads = res.data;
      });
    });
  },
  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    bbuDownloads() {
      var data = [];
      if (this.user_data !== null) {
        this.user_data.filter(function (el) {
          if (
            el.store == "mcm-s2bbu" &&
            el.first_login !== undefined &&
            el.country == "MY"
          ) {
            data.push(el);
          }
        });

        return data.length;
      }
      return 0;
    },
    jjDownloads() {
      var data = [];
      if (this.user_data !== null) {
        this.user_data.filter(function (el) {
          if (
            el.store == "mcm-s1jj" &&
            el.first_login !== undefined &&
            el.country == "MY"
          ) {
            data.push(el);
          }
        });

        return data.length;
      }
      return 0;
    },
    kl1Downloads() {
      var data = [];
      if (this.user_data !== null) {
        this.user_data.filter(function (el) {
          if (
            el.store == "mcm-k1sm" &&
            el.first_login !== undefined &&
            el.country == "MY"
          ) {
            data.push(el);
          }
        });

        return data.length;
      }
      return 0;
    },
    kl2Downloads() {
      var data = [];
      if (this.user_data !== null) {
        this.user_data.filter(function (el) {
          if (
            el.store == "mcm-k2sw" &&
            el.first_login !== undefined &&
            el.country == "MY"
          ) {
            data.push(el);
          }
        });

        return data.length;
      }
      return 0;
    },
    masaiDownloads() {
      var data = [];
      if (this.user_data !== null) {
        this.user_data.filter(function (el) {
          if (
            el.store == "mcm-s3ms" &&
            el.first_login !== undefined &&
            el.country == "MY"
          ) {
            data.push(el);
          }
        });

        return data.length;
      }
      return 0;
    },
    hqDownloads() {
      var data = [];
      if (this.user_data !== null) {
        this.user_data.filter(function (el) {
          if (
            (el.store == undefined || el.store == "" || el.store == "HQ") &&
            el.country == "MY" &&
            el.first_login !== undefined
          ) {
            data.push(el);
          }
        });

        return data.length;
      }
      return 0;
    },
    totalGmail() {
      var data = [];
      if (this.user_data !== null) {
        this.user_data.filter(function (el) {
          if (el.gemail !== undefined) {
            if (el.gemail !== "") {
              data.push(el);
            }
          }
        });

        return data.length;
      }
      return 0;
    },
    totalFB() {
      var data = [];
      if (this.user_data !== null) {
        this.user_data.filter(function (el) {
          if (el.fbemail !== undefined) {
            if (el.fbemail !== "") {
              data.push(el);
            }
          }
        });

        return data.length;
      }
      return 0;
    },
    totalApple() {
      var data = [];
      if (this.user_data !== null) {
        this.user_data.filter(function (el) {
          if (el.appleemail !== undefined) {
            if (el.appleemail !== "") {
              data.push(el);
            }
          }
        });

        return data.length;
      }
      return 0;
    },
    totalSignin() {
      var data = [];

      var startDate = null;
      var endDate = null;

      switch (this.dateSelected) {
        case "tod":
          startDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.first_login !== undefined) {
                var active_date = moment(
                  new Date(el.first_login._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (moment(active_date).isSame(startDate)) {
                  data.push(el);
                }
              }
            });

            this.bbuDls(data);
            this.jjDls(data);
            this.kl1Dls(data);
            this.kl2Dls(data);
            this.masaiDls(data);
            this.hqDls(data);

            return data.length;
          }
          break;
        case "yes":
          startDate = moment().subtract(1, "days").format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.first_login !== undefined) {
                var active_date = moment(
                  new Date(el.first_login._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (moment(active_date).isSame(startDate)) {
                  data.push(el);
                }
              }
            });
            this.bbuDls(data);
            this.jjDls(data);
            this.kl1Dls(data);
            this.kl2Dls(data);
            this.masaiDls(data);
            this.hqDls(data);

            return data.length;
          }
          break;
        case "tw":
          startDate = moment().startOf("isoweek").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.first_login !== undefined) {
                var active_date = moment(
                  new Date(el.first_login._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });
            this.bbuDls(data);
            this.jjDls(data);
            this.kl1Dls(data);
            this.kl2Dls(data);
            this.masaiDls(data);
            this.hqDls(data);

            return data.length;
          }
          break;
        case "lw":
          startDate = moment()
            .startOf("isoWeek")
            .subtract(7, "days")
            .format("YYYY-MM-DD");
          endDate = moment()
            .startOf("isoWeek")
            .subtract(1, "days")
            .format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.first_login !== undefined) {
                var active_date = moment(
                  new Date(el.first_login._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });
            this.bbuDls(data);
            this.jjDls(data);
            this.kl1Dls(data);
            this.kl2Dls(data);
            this.masaiDls(data);
            this.hqDls(data);

            return data.length;
          }
          break;
        case "l7d":
          startDate = moment().subtract(7, "days").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.first_login !== undefined) {
                var active_date = moment(
                  new Date(el.first_login._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });
            this.bbuDls(data);
            this.jjDls(data);
            this.kl1Dls(data);
            this.kl2Dls(data);
            this.masaiDls(data);
            this.hqDls(data);

            return data.length;
          }
          break;
        case "l28d":
          startDate = moment().subtract(28, "days").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.first_login !== undefined) {
                var active_date = moment(
                  new Date(el.first_login._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });
            this.bbuDls(data);
            this.jjDls(data);
            this.kl1Dls(data);
            this.kl2Dls(data);
            this.masaiDls(data);
            this.hqDls(data);

            return data.length;
          }
          break;
        case "l30d":
          startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.first_login !== undefined) {
                var active_date = moment(
                  new Date(el.first_login._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });
            this.bbuDls(data);
            this.jjDls(data);
            this.kl1Dls(data);
            this.kl2Dls(data);
            this.masaiDls(data);
            this.hqDls(data);

            return data.length;
          }
          break;
        case "l90d":
          startDate = moment().subtract(90, "days").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.first_login !== undefined) {
                var active_date = moment(
                  new Date(el.first_login._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });
            this.bbuDls(data);
            this.jjDls(data);
            this.kl1Dls(data);
            this.kl2Dls(data);
            this.masaiDls(data);
            this.hqDls(data);

            return data.length;
          }
          break;
        case "l12m":
          startDate = moment().subtract(12, "months").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.first_login !== undefined) {
                var active_date = moment(
                  new Date(el.first_login._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });
            this.bbuDls(data);
            this.jjDls(data);
            this.kl1Dls(data);
            this.kl2Dls(data);
            this.masaiDls(data);
            this.hqDls(data);

            return data.length;
          }
          break;
        case "custom":
          startDate = this.dates[0];
          endDate = this.dates[1];
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.first_login !== undefined) {
                var active_date = moment(
                  new Date(el.first_login._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });
            this.bbuDls(data);
            this.jjDls(data);
            this.kl1Dls(data);
            this.kl2Dls(data);
            this.masaiDls(data);
            this.hqDls(data);

            return data.length;
          }
          break;
        default:
          startDate = moment("2021-04-26");
          endDate = moment();
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.first_login !== undefined) {
                var active_date = moment(
                  new Date(el.first_login._seconds * 1000)
                );
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });
            this.bbuDls(data);
            this.jjDls(data);
            this.kl1Dls(data);
            this.kl2Dls(data);
            this.masaiDls(data);
            this.hqDls(data);

            return data.length;
          }
          break;
      }
      return 0;
    },
    totalActive() {
      var data = [];
      var startDate = null;
      var endDate = null;

      switch (this.dateSelected) {
        case "tod":
          startDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.last_active !== undefined) {
                var active_date = moment(
                  new Date(el.last_active._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (moment(active_date).isSame(startDate)) {
                  data.push(el);
                }
              }
            });

            return data.length;
          }
          break;
        case "yes":
          startDate = moment().subtract(1, "days").format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.last_active !== undefined) {
                var active_date = moment(
                  new Date(el.last_active._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (moment(active_date).isSame(startDate)) {
                  data.push(el);
                }
              }
            });

            return data.length;
          }
          break;
        case "tw":
          startDate = moment().startOf("isoweek").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.last_active !== undefined) {
                var active_date = moment(
                  new Date(el.last_active._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });

            return data.length;
          }
          break;
        case "lw":
          startDate = moment()
            .startOf("isoWeek")
            .subtract(7, "days")
            .format("YYYY-MM-DD");
          endDate = moment()
            .startOf("isoWeek")
            .subtract(1, "days")
            .format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.last_active !== undefined) {
                var active_date = moment(
                  new Date(el.last_active._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });

            return data.length;
          }
          break;
        case "l7d":
          startDate = moment().subtract(7, "days").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.last_active !== undefined) {
                var active_date = moment(
                  new Date(el.last_active._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });

            return data.length;
          }
          break;
        case "l28d":
          startDate = moment().subtract(28, "days").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.last_active !== undefined) {
                var active_date = moment(
                  new Date(el.last_active._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });

            return data.length;
          }
          break;
        case "l30d":
          startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.last_active !== undefined) {
                var active_date = moment(
                  new Date(el.last_active._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });

            return data.length;
          }
          break;
        case "l90d":
          startDate = moment().subtract(90, "days").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.last_active !== undefined) {
                var active_date = moment(
                  new Date(el.last_active._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });

            return data.length;
          }
          break;
        case "l12m":
          startDate = moment().subtract(12, "months").format("YYYY-MM-DD");
          endDate = moment().format("YYYY-MM-DD");
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.last_active !== undefined) {
                var active_date = moment(
                  new Date(el.last_active._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });

            return data.length;
          }
          break;
        case "custom":
          startDate = this.dates[0];
          endDate = this.dates[1];
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.last_active !== undefined) {
                var active_date = moment(
                  new Date(el.last_active._seconds * 1000)
                ).format("YYYY-MM-DD");
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });

            return data.length;
          }
          break;
        default:
          startDate = moment("2021-04-26");
          endDate = moment();
          if (this.user_data !== null) {
            this.user_data.filter(function (el) {
              if (el.last_active !== undefined) {
                var active_date = moment(
                  new Date(el.last_active._seconds * 1000)
                );
                if (
                  moment(active_date).isSameOrAfter(startDate) &&
                  moment(active_date).isSameOrBefore(endDate)
                ) {
                  data.push(el);
                }
              }
            });

            return data.length;
          }
          break;
      }
      return 0;
    },
    totalWithPoints() {
      let _this = this;
      var data = [];
      if (this.user_data !== null) {
        this.user_data.filter(function (el) {
          if (el.points !== undefined) {
            switch (_this.condition) {
              case ">=":
                if (el.points >= _this.points) {
                  data.push(el);
                }
                break;
              case "<=":
                if (el.points <= _this.points) {
                  data.push(el);
                }
                break;
              case "==":
                if (el.points == _this.points) {
                  data.push(el);
                }
                break;
            }
          }
        });

        return data.length;
      }
      return 0;
    },
    csvData() {
      var activeDate = "";

      switch (this.dateSelected) {
        case "tod":
          activeDate = "(Today)";
          break;
        case "yes":
          activeDate = "(Yesterday)";
          break;
        case "tw":
          activeDate = "(This Week [Mon - Today])";
          break;
        case "lw":
          activeDate = "(Last Week [Mon - Sun])";
          break;
        case "l7d":
          activeDate = "(Last 7 Days)";
          break;
        case "l28d":
          activeDate = "(Last 28 Days)";
          break;
        case "l30d":
          activeDate = "(Last 30 Days)";
          break;
        case "l90d":
          activeDate = "(Last 90 Days)";
          break;
        case "l12m":
          activeDate = "(Last 12 Months)";
          break;
        case "custom":
          var startDate = this.dates[0];
          var endDate = this.dates[1];
          activeDate = "(Custom [" + startDate + " - " + endDate + "])";
          break;
        default:
          activeDate = "(26 Apr 2021 - Today)";
          break;
      }

      let csvData = [
        {
          name: "Total Downloads",
          value:
            this.app_downloads.total_ios_downloads +
            this.app_downloads.total_android_downloads,
        },
        {
          name: "Total Downloads for IOS",
          value: this.app_downloads.total_ios_downloads,
        },
        {
          name: "Total Downloads for Android",
          value: this.app_downloads.total_android_downloads,
        },
        {
          name: "",
          value: "",
        },
        // {
        //   name: "Downloads from BBU",
        //   value: this.bbuDownloads,
        // },
        // {
        //   name: "Downloads from JJ",
        //   value: this.jjDownloads,
        // },
        // {
        //   name: "Downloads from KL1",
        //   value: this.kl1Downloads,
        // },
        // {
        //   name: "Downloads from KL2",
        //   value: this.kl2Downloads,
        // },
        // {
        //   name: "Downloads from Masai",
        //   value: this.masaiDownloads,
        // },
        // {
        //   name: "Downloads from HQ",
        //   value: this.hqDownloads,
        // },
        // {
        //   name: "",
        //   value: "",
        // },
        {
          name: "Total Number of Sign-ins",
          value: this.totalSignin,
        },
        {
          name: "Total Active Users " + activeDate,
          value: this.totalActive,
        },
        {
          name: "Total Users with Points " + this.condition + " " + this.points,
          value: this.totalWithPoints,
        },
        // {
        //   name: "",
        //   value: "",
        // },
        // {
        //   name: "Total Number of Social Links",
        //   value: this.totalGmail + this.totalFB + this.totalApple,
        // },
        // {
        //   name: "Gmail",
        //   value: this.totalGmail,
        // },
        // {
        //   name: "FB",
        //   value: this.totalFB,
        // },
        // {
        //   name: "Apple",
        //   value: this.totalFB,
        // },
      ];

      return csvData;
    },
  },
  methods: {
    bbuDls(data) {
      if (data.length > 0) {
        var count = data.filter((el) => {
          return el.store == "mcm-s2bbu" && el.country == "MY";
        });
        this.bbuCount = count.length;
      } else {
        this.bbuCount = 0;
      }
    },
    jjDls(data) {
      if (data.length > 0) {
        var count = data.filter((el) => {
          return el.store == "mcm-s1jj" && el.country == "MY";
        });
        this.jjCount = count.length;
      } else {
        this.jjCount = 0;
      }
    },
    kl1Dls(data) {
      if (data.length > 0) {
        var count = data.filter((el) => {
          return el.store == "mcm-k1sm" && el.country == "MY";
        });
        this.kl1Count = count.length;
      } else {
        this.kl1Count = 0;
      }
    },
    kl2Dls(data) {
      if (data.length > 0) {
        var count = data.filter((el) => {
          return el.store == "mcm-k2sw" && el.country == "MY";
        });
        this.kl2Count = count.length;
      } else {
        this.kl2Count = 0;
      }
    },
    masaiDls(data) {
      if (data.length > 0) {
        var count = data.filter((el) => {
          return el.store == "mcm-s3ms" && el.country == "MY";
        });
        this.masaiCount = count.length;
      } else {
        this.masaiCount = 0;
      }
    },
    hqDls(data) {
      if (data.length > 0) {
        var count = data.filter((el) => {
          return (
            (el.store == "HQ" || el.store == "" || el.store == undefined) &&
            el.country == "MY"
          );
        });
        this.hqCount = count.length;
      } else {
        this.hqCount = 0;
      }
    },
    changeVal() {
      this.totalWithPoints;
      this.totalActive;
    },
    goTo(view) {
      this.$store.dispatch("loadView", view);
    },
  },
};
</script>

<style scoped>
.v-h5 {
  font-size: 1.5rem;
}

.content .row {
  padding-bottom: 77px;
}

.content .header {
  font-size: 26px;
  margin-bottom: 30px;
  font-weight: normal;
}

.content .body {
  font-size: 16px;
}

.card-links {
  height: 227px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid #eeeeee;
}

.card-links > div > div {
  margin-top: 35px;
}

.download-btn {
  background: #1f4281;
  color: white;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 5px;
}
</style>
